import React from "react";
/* Importing routes and authProvider */
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { RequireAuth } from "./utils/RequireAuth";
/* Importing Components and pages */
import { Dashboard, Login, PageNotFound } from "./screens";
import {
  Locations,
  SubAdmin,
  // Promotions,
  CommunityCare,
  AddNewLocation,
  AddSubAdmin,
  AddPromotion,
  AddBlog,
  WebPromotions,
  AddWebPromotion,
  PropanePromotions,
  AddPropanePromotion,
  CommonDashboard,
  Banner,
  AddBanner,
  CoffeePromotions,
  CoffeeConfiguration,
  CoffeeSiteRewards,
  CoffeeUserRewards,
  PushNotification,
  Carousel,
  AddCarousel,
  PropanePopup,
  AddPropanePopup,
  GasLocations,
  AddNewGasLocation,
} from "./screens/dashboard/dashboardScreens";
/* Importing stylesheets */
import "./App.scss";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        >
          {/* Dashboard routes descendants */}
          <Route index element={<CommonDashboard />} />
          <Route path="locations" element={<Locations />} />
          <Route path="gas-plus-locations" element={<GasLocations />} />
          <Route path="subAdmin" element={<SubAdmin />} />
          <Route path="propane-promotions">
            <Route index element={<PropanePromotions />} />
            <Route path="add" element={<AddPropanePromotion />} />
            <Route path="edit" element={<AddPropanePromotion />} />
          </Route>
          <Route path="webPromotions" element={<WebPromotions />} />
          <Route path="banner" element={<Banner />} />
          <Route path="communityCare" element={<CommunityCare />} />
          <Route path="addNewLocation" element={<AddNewLocation />} />
          <Route
            path="add-new-gas-plus-location"
            element={<AddNewGasLocation />}
          />
          <Route path="addSubAdmin" element={<AddSubAdmin />} />
          <Route path="addSubAdmin/:userId" element={<AddSubAdmin />} />
          <Route path="addPromotion" element={<AddPromotion />} />
          <Route path="addWebPromotion" element={<AddWebPromotion />} />
          <Route path="addBlog" element={<AddBlog />} />
          <Route path="addBanner" element={<AddBanner />} />
          <Route path="push-notification" element={<PushNotification />} />
          <Route path="propane-popup">
            <Route index element={<PropanePopup />} />
            <Route path="add" element={<AddPropanePopup />} />
            <Route path="edit" element={<AddPropanePopup />} />
          </Route>
          <Route path="carousel">
            <Route index element={<Carousel />} />
            <Route path="add" element={<AddCarousel />} />
            <Route path="edit" element={<AddCarousel />} />
          </Route>
          <Route path="coffee-promotions">
            <Route index element={<CoffeePromotions />} />
            <Route path="configurations" element={<CoffeeConfiguration />} />
            <Route path="site-rewards" element={<CoffeeSiteRewards />} />
            <Route path="user-rewards" element={<CoffeeUserRewards />} />
          </Route>
        </Route>
        {/* If page is not found! */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <ToastContainer theme="dark" style={{ fontSize: "15px" }} />
    </AuthProvider>
  );
}

export default App;
